module.exports = __webpack_public_path__ + "assets/devices/Smart-Ceiling-SR-16e390a48b4ee91162c988bad6e4c12d.svg";